<template>
  <div class="pt-100">
    <div class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">Nos produits</h2>
            <p class="lead text-muted">
              Une large gamme de produits pensés pour vous aider à dépasser vos
              objectifs en termes de communication.
            </p>
          </div>
        </div>

        <div class="row">
          <div
            class="col-md-6 col-lg-4"
            data-aos="fade-up"
            data-aos-duration="1000"
            v-for="(item, index) in AllProduits"
            :key="index"
          >
            <div class="px-2 pt-4" @click="handleSlideClick(item)">
              <img
                v-lazy="item.image"
                :alt="item.alt"
                id="membreImg"
                class="img-center img-fluid shadow shadow-lg--hover"
              />

              <div class="pt-4 text-center">
                <h6 class="title">
                  <div class="d-block mb-1">{{ item.title }}</div>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import velo from "../../public/img/theme/velopic.jpg";
import moving from "../../public/img/theme/celtiis/movingboard.jpeg";
import telephone from "../../public/img/theme/telephone.jpg";
import journal from "../../public/img/theme/celtiis/journal.jpeg";
import quadra from "../../public/img/theme/quadra.jpg";
import vente from "../../public/img/theme/biscolala.jpeg";

export default {
  name: "produits",
  components: {},
  data: function() {
    return {
      AllProduits: [
        {
          title: "Le vélo publicitaire",
          image: velo,
          slug: "moving board",
          description:
            "À l'ère de la saturation numérique, il est crucial de se démarquer avec des solutions innovantes et écologiques. Le vélo publicitaire offre une plateforme unique pour promouvoir votre marque de manière dynamique et durable. Equipé d'un panneau publicitaire personnalisé, il devient un ambassadeur mobile de votre message, captant l'attention dans les zones urbaines animées, sur les promenades côtières, lors des événements sportifs ou culturels.",
          imageSrc: "velo",
        },
        {
          title: "Le Moving Board",
          image: moving,
          slug: "moving board",
          description:
            "Communément appelé  \"hommes sandwiches\", les moving boards attirent l'attention en présentant le message publicitaire de manière directe et souvent originale. Ils peuvent se déplacer dans des zones très fréquentées où d'autres formes de publicité ne sont pas possibles comme les panneaux publicitaires statiques.<br /><br />En étant mobiles et en interagissant directement avec les passants, les \"hommes sandwiches\" peuvent susciter une réponse immédiate du public. Cela peut inclure des questions sur le produit ou service promu, des demandes d'informations supplémentaires, ou même des photos partagées sur les réseaux sociaux, augmentant ainsi l'engagement. <br /><br />Ils peuvent être facilement déployées et adaptées à différents lieux et événements. Cela permet de cibler spécifiquement les zones où se trouve le public cible et où une visibilité maximale est souhaitée.",
          imageSrc: "mooving",
        },
        {
          title: "Le tricycle",
          slug: "moving board",
          image: telephone,
          description:
            "Le téléphone géant est une forme de publicité mobile qui utilise un tricycle spécialement équipé pour afficher des messages publicitaires.<br /><br />Ces tricycles se déplacent directement parmi les piétons et les véhicules, attirant ainsi une attention significative et offrant une meilleure exposition que les panneaux publicitaires. Les tricycles peuvent être dirigés vers des zones spécifiques où se trouve le public cible, comme les centres-villes,  les festivals, les événements sportifs, ou les lieux de rassemblement ; ils peuvent être facilement adaptées pour refléter les thèmes saisonniers, les tendances locales, ou les promotions spéciales, offrant ainsi une grande flexibilité créative.",
          imageSrc: "telephone",
        },
        {
          title: "Le Journal Géant",
          image: journal,
          slug: "journal pub",
          description:
            "La lecture est faite pour être partagée. C’est en tout cas le message que semble afficher le journal de 1,40 m de large que nous faisons imprimer avec vos messages. Il ressemble à une véritable « une », tout droit sortie de la presse quotidienne. Mais c’est surtout de vous qu’elle parle ! <br /><br />Sa double page suffit pour attirer toute l’attention dont vous avez besoin : grâce à sa taille impressionnante, elle se repère de loin. En apercevant ces articles de presse surdimensionnés, chacun a envie de lire par-dessus l’épaule de celui qui les tient. Nous avons souvent vu des personnes se rapprocher subrepticement pour comprendre ce qu’il se passait autour de ces quotidiens géants.<br /><br />Et nous faisons tout pour les mettre en valeur : nos hôtesses s’installent confortablement mais, surtout, bien en vue. Les lieux stratégiques de la ville ne manquent pas pour faire une bonne impression et nous les connaissons tous.",
          imageSrc: "journal",
        },
        {
          title: "Quadra Vision Lumineux",
          image: quadra,
          slug: "quadra",
          description:
            "Le Quadra vision lumineux est un dispositif innovant et hautement attractif pour captiver l'attention du public. Ce dispositif utilise des écrans LED haute résolution disposés sur quatre faces d'une structure, permettant ainsi une visibilité maximale et une diffusion dynamique de contenus visuels. Grâce à sa conception 360 degrés, le Quadra vision lumineux offre une visibilité optimale quel que soit l'angle de vue, ce qui en fait un choix idéal pour les campagnes publicitaires urbaines et événementielles. Sa capacité à diffuser des images et des animations de haute qualité en fait un outil puissant pour engager et informer efficacement le public cible.",
          imageSrc: "quadra",
        },
        {
          title: "Prospection commerciale",
          image: vente,
          slug: "vente commerciale",
          description:
            "La distribution de flyers est une stratégie de marketing direct où des flyers (ou dépliants publicitaires) sont distribués manuellement à des personnes dans des lieux publics ou ciblés. Utilisés pour promouvoir des produits, services, événements ou promotions spécifiques, l'objectif ici  est d'atteindre directement le public cible dans des lieux stratégiques comme les centres commerciaux, les rues commerçantes, les événements sportifs ou culturels, les stations. Ils sont conçus pour être visuellement attrayants et informatifs.<br /><br />Nos équipes sont déployées sur le terrain pour distribuer les flyers à des passants ou des consommateurs potentiels.Ils permettent une large portée, d'atteindre un grand nombre de personnes dans des zones fréquentées et sont relativement peu coûteuses. Nous mesurons l'efficacité de nos campagne en suivant le taux de conversion des offres spéciales ou en demandant aux clients comment ils ont découvert l'entreprise.",
          imageSrc: "vente",
        },
        {
          title: "Auto Pub",
          image: telephone,
          slug: "moving board",
          description:
            "L'auto pub utilise des véhicules comme support pour promouvoir des marques, des produits ou des services à travers l'application d'autocollants ou de vinyles imprimés sur les portières, les fenêtres arrière ou le capot. Les véhicules circulent dans diverses zones géographiques, permettant ainsi d'atteindre un large public dans différents contextes.<br /><br />Cette forme de publicité capte l'attention des passants et des automobilistes, offrant un impact visuel fort et mémorable. Comparée à d'autres formes de publicité traditionnelles, elle peut être plus rentable tout en assurant une exposition continue sur une période prolongée.<br /><br />Pour mesurer efficacement l'impact des campagnes de publicité sur véhicules, des outils sont disponibles pour fournir des données quantitatives sur la portée et l'efficacité des publicités. Les matériaux utilisés, tels que les vinyles et les autocollants, sont de haute qualité pour résister aux conditions météorologiques et aux lavages de véhicules, garantissant ainsi une longue durabilité de la publicité.<br /><br />En résumé, l'efficacité de l'auto pub dépend souvent du design créatif, de la visibilité du véhicule et de la pertinence géographique de la campagne, offrant ainsi une méthode flexible et rentable pour accroître la visibilité d'une marque ou d'une entreprise.",
          imageSrc: "telephone",
        },
      ],
    };
  },
  // mounted() {
  //   this.getService();
  // },
  methods: {
    handleSlideClick(item) {
      localStorage.setItem("service", JSON.stringify(item));
      this.$router.push("/service");
    },
  },
};
</script>

<style scoped>
.title {
  color: black;
  font-weight: 600;
}
img {
  object-fit: cover;
}

#membreImg {
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  #membreImg {
    width: 100%;
    max-height: 300px;
  }
}
@media (min-width: 768px) {
  #membreImg {
    width: 100%;
    height: 250px;
  }
}
</style>
